import { booleanAttribute, computed, Directive, ElementRef, inject, input } from '@angular/core';
import { FloatLabelType, MatFormFieldAppearance, SubscriptSizing } from '@angular/material/form-field';
import { UiField } from '../ui-form';
import { getValidationMessage, IMessageResolvers } from './message.helper';

@Directive()
export abstract class InputFieldBaseComponent {
  readonly field = input.required<UiField>();

  readonly messageResolvers = input<IMessageResolvers>();

  readonly floatLabel = input<FloatLabelType>('always');

  readonly appearance = input<MatFormFieldAppearance>('outline');

  readonly subscriptSizing = input<SubscriptSizing>('fixed');

  readonly ngStyle = input<object | undefined>();

  readonly onBlurFunction = input<() => void>();

  readonly onKeyFunction = input<(event?: KeyboardEvent) => void>();

  readonly onEnterFunction = input<(event?: KeyboardEvent) => void>();

  readonly iconName = input<string>();

  readonly showError = input(false, { transform: booleanAttribute });

  readonly elementRef = inject(ElementRef);
  htmlElement: HTMLElement = this.elementRef.nativeElement;

  readonly smallText = input(false, { transform: booleanAttribute });
  readonly inputTextStyle = computed(() => (this.smallText() ? 'font-size: small' : ''));

  get id(): string {
    return this.field().id;
  }

  get hasErrors(): boolean {
    return !this.field().control.valid;
  }

  get validationMessage(): string {
    return getValidationMessage(
      this.field().control,
      this.messageResolvers() || this.field().messageResolvers || this.customMessageResolver()
    );
  }

  onBlur() {
    if (this.onBlurFunction()) {
      this.onBlurFunction()();
    }
  }

  onKeyEvent(event: KeyboardEvent) {
    if (this.onKeyFunction()) {
      this.onKeyFunction()(event);
    }

    if (this.onEnterFunction() && event.keyCode === 13) {
      this.onEnterFunction()(event);
    }
  }

  customMessageResolver(): IMessageResolvers | undefined {
    return undefined;
  }
}
